// extracted by mini-css-extract-plugin
export default {"container":"Book_container__3ynRm","containerInfo":"Book_containerInfo__mRZ6t","image":"Book_image__X1F8w","title":"Book_title__z2WmO","footerInfo":"Book_footerInfo__W1RLM"};